import React from "react";
import { Outlet } from "react-router-dom";

/** Padding wrapper for nested /settings/* routes — uses full Shopify admin content width on large displays. */
export default function SettingsShell() {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "100%",
        margin: 0,
        padding: "0 max(16px, 1.25vw) 2rem",
        boxSizing: "border-box",
        minHeight: "min(100vh, 960px)",
        backgroundColor: "var(--p-color-bg, transparent)",
      }}
    >
      <Outlet />
    </div>
  );
}
